import { CommandBarButton } from '@fluentui/react';
import React from 'react';
import { Filter, PopupType, getAccessPermission, getAppStore } from '../../../../../@data';
import { hasDeleteAccess, hasUpdateAccess } from '../../../../../@data/services/UserRoleService';
import AppMessages from '../../../../../App.messages';
import { IGridV2Column } from '../../../../../layout/GridPageV2';
import { setDialogType } from '../../../../../layout/GridPageV2/@data/mutatorActions';
import messages from '../ManagePage.messages';

export function getGridColumns(formatMessage, isWindowRegularSize, routeHistory): IGridV2Column[] {
  const appStore = getAppStore();

  const columns: IGridV2Column[] = [
    {
      columnOrder: 1,
      key: 'name',
      fieldName: 'name',
      name: formatMessage(messages.name),
      minWidth: 100,
      maxWidth: 125,
      isSearchable: true,
      isVisible: true,
      isExportable: true,
      isResizable: true,
      suppressSorting: false,
    },
    {
      columnOrder: 2,
      key: 'id',
      fieldName: 'id',
      name: formatMessage(messages.id),
      minWidth: 100,
      maxWidth: 100,
      isSearchable: true,
      isVisible: true,
      isExportable: true,
      isResizable: true,
    },
    {
      columnOrder: 3,
      key: 'filterScope',
      fieldName: 'filterScope',
      name: formatMessage(messages.scope),
      minWidth: 100,
      maxWidth: 100,
      isSearchable: true,
      isVisible: true,
      isExportable: true,
    },
    {
      columnOrder: 4,
      key: 'status',
      fieldName: 'status',
      name: formatMessage(AppMessages.status),
      minWidth: 100,
      maxWidth: 100,
      isSearchable: true,
      isVisible: true,
      isExportable: true,
    },
    {
      columnOrder: 5,
      key: 'blockedUrlCount',
      fieldName: 'blockedUrlCount',
      name: formatMessage(messages.excludedURL),
      minWidth: 150,
      maxWidth: 150,
      isSearchable: true,
      isResizable: true,
      isVisible: true,
      isExportable: true,
    },
    {
      columnOrder: 6,
      key: 'blockedAdKeywordCount',
      fieldName: 'blockedAdKeywordCount',
      name: formatMessage(messages.excludedKeywords),
      minWidth: 150,
      maxWidth: 150,
      isSearchable: true,
      isResizable: true,
      isVisible: true,
      isExportable: true,
    },
    {
      columnOrder: 7,
      key: 'associatedChannelCount',
      fieldName: 'associatedChannelCount',
      name: formatMessage(messages.channelsNumber),
      minWidth: 150,
      maxWidth: 150,
      isSearchable: true,
      isResizable: true,
      isVisible: true,
      isExportable: true,
    },
    {
      columnOrder: 8,
      key: 'channelNames',
      fieldName: 'channelNames',
      name: formatMessage(messages.channelNames),
      minWidth: 150,
      maxWidth: 150,
      isSearchable: true,
      isResizable: true,
      isVisible: false,
      isExportable: true,
      onRender: (item: Filter) => item.associatedChannelIds?.join(', '),
    },
    {
      columnOrder: 9,
      key: 'startTime',
      fieldName: 'startTime',
      name: formatMessage(messages.startTime),
      minWidth: 150,
      maxWidth: 150,
      isSearchable: true,
      isResizable: true,
      isVisible: true,
      isExportable: true,
    },
    {
      columnOrder: 10,
      key: 'endTime',
      fieldName: 'endTime',
      name: formatMessage(messages.endTime),
      minWidth: 150,
      maxWidth: 150,
      isSearchable: true,
      isResizable: true,
      isVisible: false,
      isExportable: true,
    },
    {
      columnOrder: 11,
      key: 'actions',
      name: formatMessage(messages.actions),
      minWidth: 150,
      maxWidth: 150,
      isPadded: true,
      isSearchable: true,
      isVisible: true,
      suppressSorting: true,
      onRender: (item: Filter) => {
        const accessPermission = getAccessPermission(item);

        return (
          <div>
            <CommandBarButton
              id={`adunitCallout-${item.id}`}
              styles={{ root: { background: 'transparent' } }}
              iconProps={{ iconName: 'edit' }}
              ariaLabel={formatMessage(AppMessages.edit)}
              text={isWindowRegularSize ? formatMessage(AppMessages.edit) : ''}
              disabled={!hasUpdateAccess(accessPermission) || appStore?.publisher === undefined || appStore?.account === undefined}
              onClick={() =>
                routeHistory.push(`/ad-management/${appStore?.publisher?.id}-${appStore?.account?.id}/adfilter/edit/${item.id}`)
              }
            />
            <CommandBarButton
              styles={{ root: { background: 'transparent' } }}
              iconProps={{ iconName: 'Delete' }}
              text={isWindowRegularSize ? formatMessage(AppMessages.delete) : ''}
              onClick={() => setDialogType(PopupType.DeleteConfirmation)}
              disabled={!hasDeleteAccess(accessPermission)}
            />
          </div>
        );
      },
    },
  ];

  return columns;
}
